export enum PatientType {
    StandardVoucherHolder   = 1,
    FamilyVoucherHolder     = 2,
    Paired                  = 3,
    Waitlist                = 4,
    RemoteDirect            = 5,
    KflInternalDirect       = 6,
    KflRemoteDirect         = 7,
    KidneyReplacementCase   = 8,
    NkrInternalDirect       = 9,
    Unknown                 = -1
}